import React, { useState, useEffect } from 'react';
import { graphql } from 'gatsby'
import { OmButton } from '@om/component-library-react';
import { ThemeContext } from '../context/ThemeContext';
import './EventCountdownTimer.scss';

const EventCountdownTimer = ({
    eventCountdownTimerContent
}) => {
    if (!eventCountdownTimerContent) {
        return '';
    }

    const theme = React.useContext(ThemeContext);

    const {
        has_boundary,
        event_date,
        heading_text,
        sub_heading_text,
        action_button_text,
        action_button_type,
        action_button_url,
        open_tab
    } = eventCountdownTimerContent;

    const [timeLeft, setTimeLeft] = useState(0);

    const formatDate = (value) => {
        const days = Math.floor(value / (1000 * 60 * 60 * 24));
        const hours = Math.floor((value % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((value % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((value % (1000 * 60)) / 1000);

        return { days, hours, minutes, seconds };
    };

    useEffect(() => {
        const getDateDifference = () => {
            const eventDateObject = new Date(event_date);
            const now = new Date();
            const difference = eventDateObject.getTime() - now.getTime();

            if (difference <= 0) {
                setTimeLeft(0);
                return;
            }

            setTimeLeft(difference);
        };

        getDateDifference();
        const intervalId = setInterval(getDateDifference, 1000);

        return () => clearInterval(intervalId);
    }, [event_date]);

    const { days, hours, minutes, seconds } = formatDate(timeLeft);

    return (
        <section>
            <div className={`${theme} om-section`} style={{ textAlign: "center" }}>
                {has_boundary ? <div class="boundary-line-wrapper"><hr style={{ marginBottom: "0px" }} /></div> : null}
            </div>
            <div class={`om-event-countdown-timer-container`}>
                <om-section>
                    <div slot="section" style={{ textAlign: 'center' }}>
                        <p class="timer-heading">{heading_text}</p>
                        <p class="timer-subheading">{sub_heading_text}</p>
                        {timeLeft > 0 ?
                            <div class="time-block-container">
                                <div class="time-block">
                                    <p class="timer-digit">{days}</p>
                                    <p class="timer-text"> Days </p>
                                </div>
                                <div class="time-block">
                                    <p class="timer-digit">{hours}</p>
                                    <p class="timer-text">Hours</p>
                                </div>
                                <div class="time-block">
                                    <p class="timer-digit">{minutes}</p>
                                    <p class="timer-text">Minutes </p>
                                </div>
                                <div class="time-block-end">
                                    <p class="timer-digit">{seconds}</p>
                                    <p class="timer-text">Seconds </p>
                                </div>
                            </div>
                            : null}
                        <div className='timer-button'>
                            {action_button_text ?
                                <OmButton
                                    type="primary"
                                    size="large"
                                    url={action_button_url}
                                    text={action_button_text}
                                    actionType={action_button_type}
                                    iconName="arrow_forward"
                                    withIcon="true"
                                    openTab={open_tab}
                                />
                                : null}
                        </div>
                    </div>
                </om-section>
            </div>
        </section>
    );
};

export const pageQuery = graphql`
fragment EventCountdownTimer on Contentstack_event_countdown_timer {
    uid
    has_boundary
    event_date
    heading_text
    sub_heading_text
    action_button_text
    action_button_type
    action_button_url
    open_tab
  }
`;

export default EventCountdownTimer;
